<template>
    <div class="installt">
        <div class="intext">设置</div>
        <div class="addpoper" @click="openDialog">
            <div> <el-icon :size="24" color="#fff">
                    <Plus style=" margin-right: 8px" />
                </el-icon></div>
            <div style="height: 24px;">
                {{ numtext }}
            </div>
        </div>
    </div>
    <div class="xuan">
        <div class="riz">
            <div class="rizs" :class="bgc == 'rizsr1' ? 'bgc' : ''" @click="goindata">
                <div class="rizsl" :class="bgc == 'rizsr1' ? 'rizsl2' : 'rizsl'">
                    <img style="width: 20px;height: 20px;" src="../../assets/install/install.png" alt="">
                </div>
                <div class="rizsr">
                    <div>操作日志</div>
                    <div class="rizsrs" title="可记录用户登录、修改资料、删除数据等操作行为。">可记录用户登录、修改资料、删除数据等操作行为。</div>
                </div>
            </div>
            <div class="rizs" :class="bgc == 'rizsr2' ? 'bgc' : ''" @click="goperpo">
                <div class="rizsl" :class="bgc == 'rizsr2' ? 'rizsl2' : 'rizsl'">
                    <img style="width: 14px;height: 19px;" src="../../assets/install/pepol.png" alt="">
                </div>
                <div class="rizsr">
                    <div>员工账号设置</div>
                    <div class="rizsrs" title="可设置管理员拥有所有权限，编辑拥有编辑权限，普通员工拥有查看权限。"> 可设置管理员拥有所有权限，编辑拥有编辑权限，普通员工拥有查看权限。</div>
                </div>
            </div>
            <div class="rizs" :class="bgc == 'rizsr3' ? 'bgc' : ''" @click="gomian">
                <div class="rizsl" :class="bgc == 'rizsr3' ? 'rizsl2' : 'rizsl'">
                    <img style="height: 14px;width: 19px;" src="../../assets/install/lun.png" alt="">
                </div>
                <div class="rizsr">
                    <div>轮播图设置</div>
                    <div class="rizsrs" title="设置为轮播图，并添加跳转到产品详情页面的链接。">设置为轮播图，并添加跳转到产品详情页面的链接。</div>
                </div>
            </div>
            <div class="rizs" :class="bgc == 'rizsr4' ? 'bgc' : ''" @click="juese">
                <div class="rizsl" :class="bgc == 'rizsr4' ? 'rizsl2' : 'rizsl'">
                    <img style="width: 21px;height: 24px;" src="../../assets/install/quanxian.png" alt="">
                </div>
                <div class="rizsr">
                    <div>权限设置</div>
                    <div class="rizsrs" title="可设置只有管理员才能访问系统设置页面。">可设置只有管理员才能访问系统设置页面。</div>
                </div>
            </div>
        </div>
        <div class="xuans">

            <router-view v-slot="{ Component }">
                <KeepAlive>
                    <Component :is="Component"></Component>
                </KeepAlive>
            </router-view>


        </div>

    </div>
    <yc-mask ref="maskRef" :close-on-click-modal="false">
        <div class="dialog" v-if="bgc === 'rizsr3'">
            <div class="dialogt">
                <div>
                    添加轮播图片
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>
            <div class="lianjie">图片链接</div>
            <div class="imghttp">
                <img style="width: 22px;height: 22px;" src="../../assets/install/link.png" alt="">
                <input type="text" v-model="detail" placeholder="请填写图片的跳转链接，非必填">
            </div>
            <div class="imgshang">图片上传</div>
            <div class="bengdi">
                <div class="setupimg">
                    <div class="seimg">
                        <input type="file" id="avatar" name="avatar" accept="image/png, image/jpeg" ref="inputRef"
                            @change="tirggerFile($event)" />
                    </div>
                    <div class="jia">
                        <el-icon :size="80" color="#D8D8D8">
                            <Plus />
                        </el-icon>
                    </div>
                    <div class="images" v-if="imgUrl != ''" @click="openImg">
                        <img style="width:100%;height: 100%;" :src="imgUrl" />
                    </div>
                    <div class="tioajian">请上传一张图片，宽度320*高度480，</div>
                </div>
            </div>
            <div v-if="imgUrl != ''">
                <el-progress :percentage="progres" />
            </div>
            <div style="display: flex;justify-content: center;align-items: center;margin-top: 20px;"><el-switch
                    v-model="carousel" /> &nbsp; 是否显示轮播图</div>
            <div class="dotoom">
                <div class="quxioa" @click="closeDialog">取消</div>
                <div class="baochun" @click="addCarousel">保存</div>
            </div>
        </div>
        <div class="roleadd" v-if="bgc === 'rizsr1' || bgc === 'rizsr2'">
            <div class="dialogt">
                <div>
                    添加员工
                </div>
                <div @click="closeDialog">
                    <el-icon>
                        <Close />
                    </el-icon>
                </div>
            </div>
            <div class="numb">
                <div class="numbl">
                    <div class="numbmsg">
                        <div class="numt">真实姓名</div>
                        <div class="numbmsgtext">
                            <input type="text" v-model="realName">
                        </div>
                    </div>
                    <div class="numbmsg">
                        <div class="numt">账号</div>
                        <div class="numbmsgtext">
                            <input type="text" v-model="username">
                        </div>
                    </div>
                    <div class="numbmsg">
                        <div class="numt">密码</div>
                        <div class="numbmsgtext">
                            <input type="text" v-model="password">
                        </div>
                    </div>
                    <div class="numbmsg">
                        <div class="numt">请重新输入密码</div>
                        <div class="numbmsgtext">
                            <input type="text" v-model="passwordov">
                        </div>
                    </div>
                </div>
                <div class="numbr">
                    <div class="numbmsg">
                        <div class="bumeer" v-for="(item, index) in choosenumb" :key="index">
                            <div class="numt">选择第{{ index + 1 }}角色权限</div>
                            <div class="numbmsgtext">
                                <el-select v-model="value[index]" class="m-2" placeholder="请选择角色" size="large"
                                    @change="selectchange">
                                    <el-option class="optiontext" v-for="item2 in item.b" :key="item2.roleId"
                                        :label="item2.roleName" :value="item2.roleId" />
                                </el-select>
                                <div class="tianjias">
                                    <div class="tianjia" v-if="index + 1 == choosenumb.length && index != 3" @click="numbmsgadd">添加</div>
                                    <div class="tianjia" v-if="index + 1 == choosenumb.length && index != 0" @click="numbmsgremove">删除
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="baochun" @click="baonumb">保存</div>
        </div>
    </yc-mask>
</template>

<script setup>
import { onMounted, ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import ycMask from '@/components/mask/mask.vue'
import store from '@/api/store'
const stores = useStore();
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus'
const router = useRouter()
let numtext = ref('添加员工')
let value = ref([])
let records = ref([])
let choosenumb = ref([])
let password = ref('')
let passwordov = ref('')
let realName = ref('')
let username = ref('')
const carousel = ref(false)
const state = reactive({
    installValue: stores.state.installbgc
});
const updateHomeBgc = (newValue) => {
    stores.commit('setinstallbgc', newValue);
}
onMounted(() => {
    console.log('state', state)
    bgc.value = state.installValue
    console.log(bgc.value)
    if (bgc.value === 'rizsr1' || bgc.value === 'rizsr2') {
        numtext.value = '添加员工'

    } else if (bgc.value === 'rizsr3') {
        numtext.value = '添加图片'

    } else if (bgc.value === 'rizsr4') {
        numtext.value = '添加角色'

    }
    pageRole()
})
const selectchange = (e) => {
    console.log(e)
    value.value.length++
    console.log(value._rawValue)
}
const baonumb = async () => {
    value.value.pop()
    if (password.value != passwordov.value) {

        ElMessage.error('密码不一致！')

    } else if (realName.value.length < 1) {

        ElMessage.error('姓名不能为空！')

    } else if (username.value.length < 1) {

        ElMessage.error('账号不能为空！')

    } else if (password.value.length < 1) {

        ElMessage.error('密码不能为空！')

    } else if (value._rawValue.length < 1) {
        ElMessage.error('至少分配一个角色！')

    }
    else {
        let data = {
            "password": password.value,
            "realName": realName.value,
            "roleIdList": value._rawValue,
            "username": username.value
        }
        console.log(data)

        const res = await store.createAdmin(data)
        console.log(res)
        if (res.success) {
            ElMessage({
                message: '创建角色成功.',
                type: 'success',
                duration: '800',
                onClose: () => {
                    router.go(0)
                }
            })
        } else {
            ElMessage.error(res.message)
        }

    }


}
const numbmsgadd = () => {
    if (choosenumb.value.length < 4) {
        let a = {
            b: records._rawValue
        }
        choosenumb.value.push(a)
    }

}
const numbmsgremove = () => {
    if (choosenumb.value.length > 1) {
        choosenumb.value.shift()
    }
}
const pageRole = async () => {
    let data = {}
    const res = await store.pageRole(data)
    records.value = res.data.records
    console.log('records.value', records)
    let a = {
        b: records._rawValue
    }

    choosenumb.value.push(a)
    console.log('records.value2', choosenumb.value)
}
let openDialog = () => {
    if (bgc.value == 'rizsr4') {
        router.push('/home/install/roleadd')
    } else if (bgc.value == 'rizsr3') {
        maskRef.value.showMask();
    }
    else {
        maskRef.value.showMask();
    }
};
const inputRef = ref(null);
let imgUrl = ref('')
let file = ref({})
const tirggerFile = (event) => {
    console.log(event)
    console.log(inputRef.value);
    file.value = event.target.files[0];
    console.log(file.value)
    // addCarousel(file)
    let url = "";
    var reader = new FileReader();
    if (file.value) {
        reader.readAsDataURL(file.value);
        reader.onload = function (e) {
            url = this.result.substring(this.result.indexOf(",") + 1);
            imgUrl.value = "data:image/png;base64," + url;
            console.log(imgUrl.value)
            // that.$refs['imgimg'].setAttribute('src','data:image/png;base64,'+url);
        };
    }

}
let progres = ref(0)
let detail = ref('')
//上传图片
const addCarousel = async () => {
    const formData = new FormData();
    let carousels
    if (carousel.value) {
        carousels = 1
    } else {
        carousels = 0

    }
    formData.append('filedata', file.value);
    formData.append('detail', detail.value);
    formData.append('carousel', carousels);
    carousel
    // formData.append('isShowCarousel', 1); 
    const res = await store.addCarousel(formData, progress => {
        console.log(`当前进度为: ${progress}%`);
        progres.value = progress
    })
    if (res.success) {
        ElMessage({
            message: '上传图片成功.',
            type: 'success',
            duration: '800',
            onClose: () => {
                router.go(0)
            }
        })
    } else {
        ElMessage.error(res.message)
    }
    console.log('progress', res)

}
const openImg = () => {
    inputRef.value.click();
}
//获取遮罩的实例
let maskRef = ref(null);
//打开弹窗

//关闭弹窗
let closeDialog = () => {
    maskRef.value.closeMask();
};
const bgc = ref('')

const goindata = () => {

    if (bgc.value != 'rizsr1') {
        bgc.value = 'rizsr1'

        updateHomeBgc(bgc.value)
        numtext.value = '添加员工'
        router.push('/home/install/installData')
    }

}
const goperpo = () => {
    if (bgc.value != 'rizsr2') {
        bgc.value = 'rizsr2'
        updateHomeBgc(bgc.value)
        numtext.value = '添加员工'
        router.push('/home/install/installperpo')
    }

}
const gomian = () => {
    if (bgc.value != 'rizsr3') {
        bgc.value = 'rizsr3'
        updateHomeBgc(bgc.value)
        numtext.value = '添加图片'
        router.push('/home/install/installmian')
    }

}
const juese = () => {
    if (bgc.value != 'rizsr4') {
        bgc.value = 'rizsr4'
        updateHomeBgc(bgc.value)
        numtext.value = '添加角色'
        router.push('/home/install/installrole')
    }
}

</script>

<style lang="scss" scoped>
::v-deep .select-trigger {
    height: 56px;

    .el-input {
        height: 56px;

        .el-input__wrapper {
            background: #FAFAFA;
            border: 1px solid transparent;
            box-shadow: none;
        }

    }
}

.bgc {
    background-color: #FAFAFA;
}

.installt {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpoper {
        width: 132px;
        height: 48px;
        background: rgba(63, 140, 255);
        box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
        border-radius: 8px;
        color: #FFFFFF;
        cursor: pointer;
        padding-left: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }
}

.xuan {
    margin-top: 48px;
    display: flex;
    height: calc(100% - 108px);


    .riz {
        width: 354px;
        background: #FFFFFF;
        border-radius: 8px;
        margin-right: 27px;
        box-sizing: border-box;

        padding: 15px 17px 0 17px;

        .rizs {
            width: 322px;
            height: 88px;
            // background: #FAFAFA;
            border-radius: 8px;
            box-sizing: border-box;
            margin-bottom: 10px;
            margin: 0 auto;

            padding: 0 0 0 15px;
            display: flex;
            align-items: center;
            // justify-content: center;

            .rizsl {
                width: 48px;
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #FAFAFA;
                margin-right: 15px;
                border-radius: 24px;
            }

            .rizsl2 {
                width: 48px;
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #FFFFFF;
                margin-right: 15px;
                border-radius: 24px;
            }

            .rizsr {
                width: 74%;
                height: 48px;
                display: flex;
                // justify-content: center;
                flex-direction: column;
                justify-content: space-around;
                // margin: 0 auto;

                .rizsrs {
                    width: 100%;
                    white-space: nowrap;

                    overflow: hidden;

                    text-overflow: ellipsis;
                }

                div:first-child {
                    font-size: 14px;
                    color: #111827;
                }

                div:last-child {
                    font-size: 12px;
                    color: #718096;
                }




            }
        }
    }

    .xuans {

        width: calc(100% - 354px - 27px);
        min-width: 915px;
        padding: 28px 27px 0 27px;
        background: #FFFFFF;
        border-radius: 18px;
        box-sizing: border-box;
    }
}

.roleadd {
    position: relative;
    width: 814px;
    height: 555px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 23px 36px 0 35px;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 13px;
    }

    .numb {
        width: 100%;
        display: flex;
        justify-content: space-around;

        .numbl {
            box-sizing: border-box;

            .numbmsg {
                width: 332px;
                font-size: 14px;
                color: #718096;
                margin-bottom: 13px;

                .numt {
                    margin-bottom: 12px;
                }

                .numbmsgtext {
                    width: 100%;
                    height: 56px;
                    background: #FAFAFA;
                    padding: 0 14px 0 14px;
                    box-sizing: border-box;


                    .m-2 {
                        width: 100% !important;
                        background: #FAFAFA;
                        height: 56px;
                    }

                    input {
                        height: 56px;
                        padding: 0;
                    }
                }

            }
        }

        .numbr {
            .numbmsg {
                font-size: 14px;
                color: #718096;
                margin-bottom: 13px;


                .bumeer:first-child {
                    margin-top: 0px;
                }

                .bumeer {
                    margin-top: 13px;

                    .numt {
                        margin-bottom: 12px;
                    }

                    .numbmsgtext {
                        width: 372px;
                        height: 56px;

                        display: flex;
                        align-items: center;

                        .tianjias {
                            display: flex;
                            justify-content: space-around;
                            flex-direction: column;
                            height: 100%;

                            .tianjia {
                                font-weight: 400;
                                color: #418EFF;
                                margin-left: 9px;
                                cursor: pointer;
                            }
                        }




                        .m-2 {
                            width: 90% !important;
                            background: #FAFAFA;
                            height: 56px;

                            .select-trigger {
                                height: 56px !important;
                            }
                        }
                    }

                }
            }

        }
    }

    .baochun {
        width: 96px;
        height: 48px;
        background: #79AFFF;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 48px;
        text-align: center;
        margin: 15px auto;
    }
}

.dialog {
    position: relative;
    width: 814px;
    height: 555px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 23px 36px 0 35px;

    .dialogt {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.88);
        margin-bottom: 13px;

    }

    .lianjie {
        font-size: 14px;
        font-weight: 600;
        color: #718096;
    }

    .imghttp {
        margin-top: 12px;
        width: 100%;
        height: 56px;
        background: #FAFAFA;
        padding-left: 10px;
        display: flex;
        align-items: center;

        input {
            padding-left: 12px;
            font-size: 16px;
            color: #111827;
            outline: none;
            background: transparent;
            border: none;
            outline: medium;
            width: 100%;
            height: 50px;
        }
    }

    .imgshang {
        font-size: 14px;
        font-weight: 600;
        color: #718096;
        margin-top: 13px;
    }

    .bengdi {
        width: 100%;
        height: 221px;
        background: #FAFAFA;
        margin-top: 12px;
        position: relative;

        .setupimg {
            width: 100%;
            height: 100%;


            .images {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                z-index: 999;
            }

            .jia {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            .seimg {

                width: 100%;
                height: 100%;

                input {
                    padding: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }
            }

            .tioajian {

                font-size: 11px;
                line-height: 23px;
                text-align: center;
                font-weight: 400;
                color: #718096;
                position: absolute;
                left: 50%;
                top: 156px;
                transform: translate(-50%, 0);
            }
        }
    }

    .dotoom {
        display: flex;
        font-size: 16px;
        font-weight: 600;
        width: 295px;
        justify-content: space-between;
        margin: 48px auto;

        div {
            text-align: center;
            line-height: 48px;
            color: #FFFFFF;
            border-radius: 8px;

        }

        .quxioa {
            width: 108px;
            height: 48px;
            border: 1px solid #979797;
            color: rgba(0, 0, 0, 0.5);
            box-sizing: border-box;
            cursor: pointer;
        }

        .baochun {
            width: 108px;
            height: 48px;
            background: #79AFFF;
            cursor: pointer;

        }

    }



}</style>